<template>
  <div>
    <q-card
      :style="metaBackground"
      @mouseover="metaOver()"
      @mouseleave="metaLeave()"
      @click="changeObjetivos()"
      bg-primary
      :class="[
        'cursor-pointer',
        objetivoEspecificoSelected === true ||
        objetivoEspecificoSelected === undefined
          ? 'selected'
          : 'noSelected'
      ]"
    >
      <div class="divNameObjetivo" v-if="objetivoEspecifico">
        {{ objetivoEspecifico.name }}
      </div>
    </q-card>
    <DialogWarning
        v-model="showDialog"
        dataCy="delete-indicador"
        :showIcon="true"
        :txtContainer="
          `Los datos introducidos no han sido guardados. Si abandona el proceso sin guardar se perderán todos los cambios.¿Desea salir del indicador?`
        "
        labelDelete="SÍ, SALIR Y PERDER TODOS LOS CAMBIOS"
        labelCancel="NO, PERMANECER EN EL INDICADOR"
        @save="saveChangesObjetivo()"
      />
  </div>
</template>
<script>
import DialogWarning from '@/shared/dialogs/warning/DialogWarning.vue';
export default {
  components: {
    DialogWarning
  },
  props: {
    objetivoEspecifico: Object,
    color: String,
    colorHover: String,
    objetivoEspecificoSelected: Boolean,
    form_dirty: Boolean
  },
  data () {
    return {
      metaBackground: {
        backgroundColor: `${this.color}`
      },
      showDialog: false
    };
  },
  watch: {
    color: {
      handler: function () {
        this.metaBackground.backgroundColor = this.color;
      },
      deep: true
    }
  },
  methods: {
    metaOver () {
      this.metaBackground.backgroundColor = this.colorHover;
    },
    metaLeave () {
      this.metaBackground.backgroundColor = this.color;
    },
    changeObjetivos () {
      if (this.form_dirty) {
        this.showDialog = true;
      } else {
        this.changeDataObjetivoEspecifico();
      }
    },
    closeDialog () {
      this.showDialog = false;
    },
    saveChangesObjetivo () {
      this.showDialog = false;
      this.$eventHub.$emit('cleanForm');
      this.changeDataObjetivoEspecifico();
    },
    changeDataObjetivoEspecifico () {
      this.$store.commit(
        'NGUD/setObjetivoEspecifico',
        { name: this.objetivoEspecifico.name, id: this.objetivoEspecifico.id }
      );
      this.$emit('updateVisibilityEspecificos', {
        idObj: this.objetivoEspecifico.id
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.selected {
  opacity: 1;
}
.noSelected {
  opacity: 0.57;
}
div {
  height: 100%;
}
.divNameObjetivo {
  font-family: DINPro;
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.2px;
  color: #4c4c4c;
}
</style>
